
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { updateUser } from "@/api/apiService";
import { toast } from "sonner";
import { ProfileContentProps } from "@/features/user/userSlice";

export const ProfileContent = ({ user }: ProfileContentProps) => {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [loading, setLoading] = useState(false);

  const handleSaveChanges = async () => {
    setLoading(true);
    try {
      await updateUser({ name, email });
      toast.success("Profile updated successfully!");
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error(error.response?.data?.message || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div>
        <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">Profile Information</h3>
        <div className="space-y-4">
          <div>
            <Label className="text-sm font-medium">Full Name</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 h-10 md:h-11"
            />
          </div>
          <div>
            <Label className="text-sm font-medium">Email</Label>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 h-10 md:h-11"
              type="email"
            />
          </div>
        </div>
      </div>

      {/*<div>*/}
      {/*  <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">Travel Statistics</h3>*/}
      {/*  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">*/}
      {/*    <Card className="p-3 md:p-4 bg-primary/5">*/}
      {/*      <div className="flex items-center gap-3 md:gap-4">*/}
      {/*        <BookMarked className="h-6 w-6 md:h-8 md:w-8 text-primary" />*/}
      {/*        <div>*/}
      {/*          <p className="text-xl md:text-2xl font-bold">{user.savedGuides}</p>*/}
      {/*          <p className="text-xs md:text-sm text-muted-foreground">Saved Guides</p>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </Card>*/}
      {/*    <Card className="p-3 md:p-4 bg-primary/5">*/}
      {/*      <div className="flex items-center gap-3 md:gap-4">*/}
      {/*        <Clock className="h-6 w-6 md:h-8 md:w-8 text-primary" />*/}
      {/*        <div>*/}
      {/*          <p className="text-xl md:text-2xl font-bold">{user.completedTrips}</p>*/}
      {/*          <p className="text-xs md:text-sm text-muted-foreground">Completed Trips</p>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </Card>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className="flex justify-center md:justify-end w-full">
        <Button
          onClick={handleSaveChanges}
          disabled={loading}
          className="w-full md:w-auto"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Saving...
            </>
          ) : (
            "Save Changes"
          )}
        </Button>
      </div>
    </div>
  );
};
